import type { Coords, Placement } from '@floating-ui/react-dom';
import React, { forwardRef } from 'react';
import * as styles from './FloatingArrow.module.scss';

interface FloatingArrowProps {
  placement: Placement;
  arrowData?: Partial<Coords>;
}

const FloatingArrow = forwardRef<HTMLDivElement, FloatingArrowProps>(
  ({ placement, arrowData }, ref) => (
    <div
      ref={ref}
      data-placement={placement}
      className={styles.arrow}
      style={arrowData ? { left: arrowData.x, top: arrowData.y } : undefined}
    />
  ),
);

export default FloatingArrow;
